<template>
	<!-- <div :style="'height:700px; width:' + operation == 'S' ? '1200px;' : '900px;'" v-on:keyup.esc="close()"> -->
	<div :style="operation == 'S' ? (user.company_id == 'newjigu' || user.company_id == 'jc' ? 'width:1400px;' : 'width:1100px;') : 'width:1000px;'" v-on:keyup.esc="close()">
		<div class="left_option">
			<em v-if="false" class="lt_text">Item {{ headers.class }}</em>
			<span v-if="false" class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" v-on:ok="search()" /> </span>

			<span class="int_type half_int mgr_10">
				<!-- <input type="text" v-model.trim="keyword" placeholder="Keyword or Barcode" ref="spkeyword" autofocus autocomplete="off" @keydown.enter="search()" /> -->
				<AC
					ref="ac"
					v-model.trim="keyword"
					:initialDisplay="keyword"
					:source="selectClasses"
					:focusOnAC="focusOnAC"
					@result="test2"
					@nothingSelected="searchKeyword"
					@selected="selectClass"
					@enter="acEnter"
					@focus="acFocus"
					results-display="code_name"
					placeholder="Item / Class Name or Code"
				>
				</AC>
			</span>

			<span v-if="operation == 'S'" class="int_type mgr_5">
				<currency-input
					type="text"
					style="width:120px;"
					v-model.trim="batchQuantity"
					:precision="0"
					:allow-negative="false"
					class="int_type al_right"
					placeholder="Qty for checked"
					@focus="$event.target.select()"
					@keyup.enter="batchApplyQuantity()"
				/>
			</span>
			<a v-if="operation == 'S'" href="javascript:;" type="button" class="search_bt mgr_15" @click="batchApplyQuantity()">Apply</a>

			<a v-if="imageFileName" href="javascript:;" type="button" class="gray_bt2" @click="viewImage()">View Image</a>
			<img v-img="{ sourceButton: false }" ref="image" v-if="imageFileName" :src="getImageUrl()" alt="" style="cursor: zoom-in;max-height:22px;max-width:30px;height:auto;width:auto;" />
		</div>
		<div class="view_inner">
			<!-- <span class="int_type mm_int"><input type="text" class="mm_int" v-model="filter" ref="spFilter" placeholder="Filter by name" autofocus autocomplete="off"/></span>
			<a href="javascript:;" class="gray_bt" @click="clear()">Clear</a> -->
			<div class="fixed-table-container" ref="div_wrapper_parent" :style="'height:' + (user.company_id == 'jc' ? '320' : '600') + 'px;'">
				<div class="table-wrapper" ref="div_wrapper">
					<table id="item_list" class="list_tbl">
						<thead>
							<tr>
								<th v-if="operation == 'S'" style="text-align:center;width:30px;">
									<div class="th-text "><input type="checkbox" @change="selectAll()" v-model="allSelected" /></div>
								</th>

								<th style="text-align:center;width:30px;"><div class="th-text">#</div></th>

								<th v-if="user.company_id == 'he'" style="text-align:center;width:120px;"><div class="th-text ">Item Code</div></th>
								<th v-else style="text-align:center;width:90px;">
									<div class="th-text">{{ headers.class }}</div>
								</th>

								<th style="text-align:center;"><div class="th-text ">Name</div></th>
								<th v-if="user.company_id != 'newjigu'" style="text-align:center;width:30px;"><div class="th-text">FS</div></th>

								<th style="text-align:center;width:90px;" v-if="user.company_id != 'jc'"><div class="th-text">Color</div></th>
								<th v-if="user.company_id != 'jc'" style="text-align:center;width:40px;"><div class="th-text">PCS</div></th>

								<th v-if="false && user.company_id == 'newjigu' && operation == 'S'" style="text-align:center;width:240px;"><div class="th-text">Pre-Defined Qty</div></th>

								<th v-if="user.company_id == 'jc' && operation == 'P'" style="text-align:center;width:40px;"><div class="th-text">U/M</div></th>
								<th v-if="user.company_id == 'jc' && operation == 'P'" style="text-align:center;width:40px;"><div class="th-text">S.U/M</div></th>
								<th style="text-align:center;width:50px;"><div class="th-text ">Qty.</div></th>
								<th v-if="user.company_id == 'jc' && operation == 'S'" style="text-align:center;width:40px;"><div class="th-text">U/M</div></th>
								<th v-if="user.company_id == 'jc'" style="text-align:center;width:70px;"><div class="th-text">P. Unit</div></th>
								<th v-if="!fromWarehouse" style="text-align:center;width:65px;"><div class="th-text ">Price</div></th>
								<th v-if="user.company_id == 'jc' && operation == 'P'" style="text-align:center;width:55px;"><div class="th-text ">QTY/CTN</div></th>

								<template v-if="operation == 'S'">
									<th v-if="!fromWarehouse" style="text-align:center;width:65px;"><div class="th-text ">Req.P.</div></th>
									<th v-if="!fromWarehouse" style="text-align:center;width:55px;"><div class="th-text ">Last($)</div></th>
									<th v-if="user.company_id == 'newjigu'" style="text-align:center;width:80px;"><div class="th-text ">L.S.Date</div></th>
									<th v-if="user.company_id == 'newjigu'" style="text-align:center;width:50px;"><div class="th-text ">L.S.Qty.</div></th>
									<th v-if="!fromWarehouse && (user.company_id != 'beautyplus' || user.lock_price_view)" style="text-align:center;width:55px;"><div class="th-text">Lock($)</div></th>
									<th v-if="user.company_id != 'newjigu' && user.company_id != 'hairplus' && !fromWarehouse" style="text-align:center;width:55px;"><div class="th-text">Min($)</div></th>
									<th v-if="user.company_id == 'jc' || user.company_id == 'hairplus'" style="text-align:center;width:55px;"><div class="th-text">S ($)</div></th>
									<th v-if="user.company_id == 'newjigu' || user.company_id == 'jc'" style="text-align:center;width:55px;"><div class="th-text">A ($)</div></th>
									<th v-if="user.company_id == 'newjigu' || user.company_id == 'jc'" style="text-align:center;width:55px;"><div class="th-text">B ($)</div></th>
									<th v-if="user.company_id == 'newjigu' || user.company_id == 'jc'" style="text-align:center;width:55px;"><div class="th-text">C ($)</div></th>
									<th style="text-align:center;width:55px;" v-if="user.cost_view_yn == 'Y'"><div class="th-text">Cost($)</div></th>
								</template>
								<template v-else-if="operation == 'P'">
									<th style="text-align:center;width:55px;"><div class="th-text ">L.PO($)</div></th>
									<th style="text-align:center;width:55px;"><div class="th-text ">L.SH($)</div></th>
									<th style="text-align:center;width:55px;"><div class="th-text">Cost</div></th>
								</template>
								<template v-else>
									<th style="text-align:center;width:55px;"><div class="th-text">Cost</div></th>
								</template>

								<template v-if="user.company_id == 'jc' && operation != 'P'">
									<th style="text-align:center;width:40px;"><div class="th-text">WH1</div></th>
									<th style="text-align:center;width:40px;"><div class="th-text">WH2</div></th>
								</template>
								<template v-else>
									<th style="text-align:center;width:40px;"><div class="th-text">On-H.</div></th>
								</template>

								<th v-if="!(user.company_id == 'jc' && operation == 'P')" style="text-align:center;width:40px;"><div class="th-text">Avail</div></th>
								<th v-if="user.company_id == 'newjigu' && operation == 'S'" style="text-align:center;width:45px;"><div class="th-text">Pend30</div></th>
								<th v-if="user.company_id == 'newjigu' && operation == 'S'" style="text-align:center;width:45px;"><div class="th-text">Pend90</div></th>
								<th v-if="user.company_id == 'newjigu'" style="text-align:center;width:45px;"><div class="th-text">On O.</div></th>
								<th v-if="user.company_id == 'jc' && operation == 'P'" style="text-align:center;width:45px;"><div class="th-text">On S/O</div></th>
								<th v-if="!fromWarehouse" style="text-align:center;width:40px;"><div class="th-text">On B.</div></th>
								<th v-if="!fromWarehouse" style="text-align:center;width:85px;"><div class="th-text">Arr Date</div></th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(item, index) in items" v-bind:key="item.item_id">
								<td v-if="operation == 'S'" class="al_center"><input type="checkbox" v-model="item.selected2" /></td>
								<td class="al_right">{{ index + 1 }}</td>

								<td v-if="user.company_id == 'he'">{{ item.item_code }}</td>
								<td v-else>{{ item.class_code }}</td>

								<!-- <td class="truncate"> -->
								<td class="al_left truncate">
									<b v-if="item.active_yn == 'N'"><font color="red">!!</font></b>
									{{ item.name }}
									<!-- <template v-if="item.first_sale"> <font color="blue">FS!!</font></template> -->
								</td>
								<td v-if="user.company_id != 'newjigu'" class="al_center">
									<span v-if="item.first_sale"><font color="blue">&#10004;</font></span>
								</td>

								<td v-if="user.company_id != 'jc'">{{ item.color_code }}</td>
								<td v-if="user.company_id != 'jc'" class="al_right">{{ item.packing }}</td>

								<td v-if="false && user.company_id == 'newjigu' && operation == 'S'" class="al_center">
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 1)">1</a>
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 5)">5</a>
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 10)">10</a>
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 20)">20</a>
									<a href="javascript:;" type="button" class="gray_bt3" @click="addQuantity(item, 50)">50</a>
									<a href="javascript:;" type="button" class="gray_bt3" style="margin-left:5px;" @click="clearQuantity(item)">CLR</a>
								</td>

								<td v-if="user.company_id == 'jc' && operation == 'P'" class="al_center">{{ item.purchase_unit_code }}</td>
								<td v-if="user.company_id == 'jc' && operation == 'P'" class="al_center">{{ item.unit_code }}</td>
								<td class="al_right">
									<!-- <money type="text" v-model="item.quantity" :ref="'quantity'" class="r_int long_type al_right" v-on:keyup.down="test()" /> -->
									<currency-input
										type="text"
										ref="quantity"
										v-model.trim="item.quantity"
										:precision="0"
										:allow-negative="operation == 'N' ? true : false"
										class="r_int long_type al_right"
										@keydown.down.prevent="keyDown('quantity', index)"
										@keydown.up.prevent="keyUp('quantity', index)"
										@keydown.enter.prevent="keyEnter('quantity', index, $event)"
										@keydown.right.prevent="keyRight('quantity', index)"
										@keydown.left.prevent="keyLeft('quantity', index)"
										@focus="$event.target.select()"
										@keydown.ctrl.enter.prevent="ok()"
										@drop.prevent=""
									/>
								</td>
								<td v-if="user.company_id == 'jc' && operation == 'S'" class="al_center">{{ item.unit_code }}</td>
								<td v-if="user.company_id == 'jc'" class="al_center">{{ item.packing_unit }}</td>
								<template v-if="operation == 'S'">
									<td v-if="!fromWarehouse" class="al_right">
										<currency-input
											type="text"
											ref="price"
											v-model="item.net_price"
											class="r_int long_type al_right"
											:disabled="user.price_adjust_yn == 'N'"
											@focus="$event.target.select()"
											@keydown.down.prevent="keyDown('price', index)"
											@keydown.up.prevent="keyUp('price', index)"
											@keydown.enter.prevent="keyDown('price', index)"
											@keydown.right.prevent="keyRight('price', index)"
											@keydown.left.prevent="keyLeft('price', index)"
											@input="priceInputEvent(index, 'N', item.class_code, item.min_price, item.cost, $event)"
											:valueRange="{ min: user.to_min_price_adjust_yn == 'Y' ? (user.to_lock_price_adjust_yn == 'Y' ? 0 : item.min_price) : item.last_net_price ? Math.min(item.min_price, item.last_net_price) : item.min_price }"
											@keydown.ctrl.enter.prevent="ok()"
											@drop.prevent=""
										/>
									</td>
								</template>
								<template v-else>
									<td v-if="!fromWarehouse" class="al_right">
										<currency-input
											type="text"
											ref="price"
											v-model="item.net_price"
											:precision="operation == 'P' ? profile.po_decimal_point : 2"
											class="r_int long_type al_right"
											@focus="$event.target.select()"
											@keydown.down.prevent="keyDown('price', index)"
											@keydown.up.prevent="keyUp('price', index)"
											@keydown.enter.prevent="keyDown('price', index)"
											@keydown.right.prevent="keyRight('price', index)"
											@keydown.left.prevent="keyLeft('price', index)"
											@input="priceInputEvent(index, null, item.class_code, item.min_price, item.cost, $event)"
											@keydown.ctrl.enter.prevent="ok()"
											@drop.prevent=""
										/>
									</td>
								</template>

								<td v-if="user.company_id == 'jc' && operation == 'P'" class="al_right">{{ item.packing }}</td>

								<template v-if="operation == 'S'">
									<td v-if="!fromWarehouse" class="al_right">
										<currency-input
											type="text"
											ref="req_price"
											v-model="item.r_price"
											class="r_int long_type al_right"
											@focus="$event.target.select()"
											@keydown.down.prevent="keyDown('req_price', index)"
											@keydown.up.prevent="keyUp('req_price', index)"
											@keydown.enter.prevent="keyDown('req_price', index)"
											@keydown.right.prevent="keyRight('req_price', index)"
											@keydown.left.prevent="keyLeft('req_price', index)"
											@input="priceInputEvent(index, 'R', item.class_code, item.min_price, item.cost, $event)"
											:valueRange="{ min: user.company_id == 'beautyplus' ? item.lock_price : 0 }"
											@keydown.ctrl.enter.prevent="ok()"
											@drop.prevent=""
										/>
									</td>
									<td v-if="!fromWarehouse" class="al_right">{{ item.last_net_price | toCurrency }}</td>
									<td v-if="user.company_id == 'newjigu'" class="al_left">{{ item.last_sale_date }}</td>
									<td v-if="user.company_id == 'newjigu'" class="al_right">
										<font :color="item.last_sale_quantity < item.last_order_quantity ? 'red' : 'black'">{{ item.last_sale_quantity | commaSeparated }}</font>
									</td>
									<td v-if="!fromWarehouse && (user.company_id != 'beautyplus' || user.lock_price_view)" class="al_right">{{ item.lock_price | toCurrency }}</td>
									<td v-if="user.company_id != 'newjigu' && user.company_id != 'hairplus' && !fromWarehouse" class="al_right">{{ item.min_price | toCurrency }}</td>
									<td v-if="user.company_id == 'jc' || user.company_id == 'hairplus'" class="al_right">{{ item.s_price | toCurrency }}</td>
									<td v-if="user.company_id == 'newjigu' || user.company_id == 'jc'" class="al_right">{{ item.a_price | toCurrency }}</td>
									<td v-if="user.company_id == 'newjigu' || user.company_id == 'jc'" class="al_right">{{ item.b_price | toCurrency }}</td>
									<td v-if="user.company_id == 'newjigu' || user.company_id == 'jc'" class="al_right">{{ item.c_price | toCurrency }}</td>
									<td class="al_right" v-if="user.cost_view_yn == 'Y'">{{ item.cost | toCurrency }}</td>

									<!-- <td class="al_right">{{ item.s_price | toCurrency }}</td> -->
									<!-- <td class="al_right">{{ item.a_price | toCurrency }}</td>
									<td class="al_right">{{ item.b_price | toCurrency }}</td>
									<td class="al_right">{{ item.c_price | toCurrency }}</td>  -->
								</template>
								<template v-else-if="operation == 'P'">
									<td class="al_right">{{ item.last_net_price | toCurrency }}</td>
									<td class="al_right">{{ item.last_sh_price | toCurrency }}</td>
									<td class="al_right">{{ item.cost | toCurrency }}</td>
								</template>
								<template v-else>
									<td class="al_right">{{ item.cost | toCurrency }}</td>
								</template>

								<template v-if="user.company_id == 'jc' && operation != 'P'">
									<td class="al_right">{{ item.WH1 | commaSeparated }}</td>
									<td class="al_right">{{ item.WH2 | commaSeparated }}</td>
								</template>
								<template v-else>
									<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
								</template>
								<td v-if="!(user.company_id == 'jc' && operation == 'P')" class="al_right">{{ item.available_quantity | commaSeparated }}</td>
								<td v-if="user.company_id == 'newjigu' && operation == 'S'" class="al_right">{{ item.pending_30_quantity | commaSeparated }}</td>
								<td v-if="user.company_id == 'newjigu' && operation == 'S'" class="al_right">{{ item.pending_90_quantity | commaSeparated }}</td>
								<td v-if="user.company_id == 'newjigu'" class="al_right">
									<a href="javascript:;" @click="gotoPODetail(item)"> {{ item.po_quantity | commaSeparated }}</a>
								</td>
								<td v-if="user.company_id == 'jc' && operation == 'P'" class="al_right">{{ item.on_so | commaSeparated }}</td>
								<td v-if="!fromWarehouse" class="al_right">{{ item.on_board_quantity | commaSeparated }}</td>
								<td v-if="!fromWarehouse" class="al_left">{{ item.arrival_date }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<!-- <div class="fixed-table-container" style="height:25px;">
				<div class="table-wrapper">
					<table class="list_tbl">
						<thead>
							<tr>
								<th style="text-align:center;width:2%;"><div class="th-text"></div></th>
								<th style="text-align:center;width:6%;"><div class="th-text"></div></th>
								<th style="text-align:center;"><div class="th-text "></div></th>

								<th style="text-align:center;width:7%;"><div class="th-text"></div></th>
								<th style="text-align:center;width:3%;"><div class="th-text"></div></th>

								<th style="text-align:right;width:5%;">
									<div class="th-text">
										<span v-if="total_quantity != 0" style="padding-right:5px;">{{ total_quantity | commaSeparated }}</span>
									</div>
								</th>
								<th style="text-align:center;width:6%;"><div class="th-text "></div></th>
								<th style="text-align:center;width:6%;"><div class="th-text "></div></th>

								<template v-if="operation == 'S'">
									<th style="text-align:center;width:5%;"><div class="th-text"></div></th>
									<th style="text-align:center;width:5%;"><div class="th-text"></div></th>
									<th style="text-align:center;width:5%;" v-if="user.cost_view_yn == 'Y'"><div class="th-text"></div></th>
								</template>
								<template v-else>
									<th style="text-align:center;width:5%;"><div class="th-text"></div></th>
								</template>

								<th style="text-align:center;width:4%;"><div class="th-text"></div></th>
								<th style="text-align:center;width:4%;"><div class="th-text"></div></th>
								<th style="text-align:center;width:4%;"><div class="th-text"></div></th>
								<th style="text-align:center;width:8%;"><div class="th-text"></div></th>
							</tr>
						</thead>

						<tbody></tbody>
					</table>
				</div>
			</div> -->

			<div class="view_bottom_bt">
				<span v-if="total_quantity != 0" style="padding-right:25px">
					Total Quantity :
					<b>{{ total_quantity | commaSeparated }}</b></span
				>
				<a href="javascript:;" type="button" class="search_bt" @click="ok()">{{ soItemSelect ? 'Add (Enter)' : 'Add (Ctrl + Enter)' }}</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="close()">Close</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ItemClass'" :draggable="false" @keydown.esc.prevent="test()" style="z-index:3000">
			<template slot="title">Select Item {{ headers.class }}</template>
			<template slot="body">
				<ItemClassPopup :initialKeyword="keyword" :code_only="false" :operation="operation" :soItemSelect="so_item_filter" v-on:close="closeModal()" @close="popupCanceled" @cancel="popupCanceled" @set-item-class2="setItemClass" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'POStatus'" :draggable="false" @keydown.esc.prevent="test()">
			<template slot="title">PO Status</template>
			<template slot="body">
				<POStatusPopup :item_id="item_id" v-on:close="closeModal()" />
			</template>
		</Modal>

		<!-- <Modal @close="closeModalItems" v-if="showModal" :draggable="false">
			<template slot="title">Select Class</template>
			<template slot="body">
				<div style="width:550px; height:700px;" v-on:keyup.esc="close()">
					<div style="overflow-y: scroll;height:630px;">
						<table class="list_tbl">
							<thead>
								<tr>
									<th width="10%">Class</th>
									<th>Name</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="c in classes" v-bind:key="c.code" @click="clickClass(c)">
									<td class="al_left">{{ c.code }}</td>
									<td class="al_left">{{ c.name }}</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div class="popup_bottom">
						<a href="javascript:;" @click="closeModalItems()" class="gray_bt">Cancel</a>
					</div>
				</div>
			</template>
		</Modal> -->
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import '@/assets/css/table_box.css';
//import { apiSelectItemClassList } from '@/api/item/class.js';
import { apiSelectItemClass } from '@/api/item/class.js';
import { apiSelectItemList } from '@/api/item/master.js';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import Modal from '@/components/common/Modal';
import ItemClassPopup from '@/components/common/ItemClassPopup';
import POStatusPopup from '@/components/common/POStatusPopup';
import AC from '@/components/common/AC';
import _ from 'lodash';

export default {
	data: function() {
		return {
			items: [],
			filter: null,

			//classes: [],

			itemClass: null,
			className: null,
			keyword: '',
			prevKeyword: '',

			imageFileName: null,

			item_id: null,
			showModal: false,
			modalName: null,

			allSelected: false,
			batchQuantity: null,
		};
	},
	computed: {
		// items() {
		// 	//inputSelectOnClick();
		// 	var vm = this;
		// 	if (vm.filter) return this.initialItems.filter(m => m.name.toLowerCase().includes(vm.filter.toLowerCase()));
		// 	else return this.initialItems;
		// },
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		total_quantity: function() {
			var tot = 0;
			this.items.forEach(i => {
				if (i.quantity) tot += i.quantity;
			});
			return tot;
		},
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		// #3320: 서버 필터 키를 만드는 모든 자리가 이 하나만 쓴다. 호출부마다 조건을 반복하면
		// 한 곳이 빠졌을 때 Return SO 에서 Sales Off/비판매 클래스가 잘못 숨겨진다.
		// 키 동작(keyEnter)은 Sales/Return 둘 다 필요하므로 soItemSelect 를 그대로 쓴다.
		so_item_filter: function() {
			return this.soItemSelect && this.invoice_type != 'R';
		},
	},
	props: {
		initialItems: Array,
		initialItemClass: String,
		initialClassName: String,
		initialKeyword: String,

		ship_to_code: String,
		vendor_code: String,

		operation: {
			type: String,
			default: 'S', // S : Sales, P : Purchase
		},

		invoice_type: {
			type: String,
			default: 'S', // S :Sales, R : Return
		},

		fromWarehouse: {
			type: Boolean,
			default: false,
		},

		includeInactive: {
			type: Boolean,
			default: false,
		},
		focusOnAC: {
			type: Boolean,
		},

		// #3320: SO Detail 의 품목 선택 팝업임을 호출부가 명시적으로 켠다.
		// operation='S' 는 WH Return 도 기본값으로 갖기 때문에 SO 식별자가 될 수 없다.
		soItemSelect: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		ItemClassSelect,
		Modal,
		ItemClassPopup,
		AC,
		POStatusPopup,
	},
	methods: {
		gotoPODetail(item) {
			// let routeData = this.$router.resolve({ name: 'onOrderDetail', query: { backUri: this.uri, class_code: item.class_code } });
			// window.open(routeData.href, 'herp_on_order_detail');
			this.item_id = item.item_id;
			this.modalName = 'POStatus';
			this.showModal = true;
		},
		clearQuantity(item) {
			item.quantity = null;

			this.$forceUpdate();
		},
		addQuantity(item, qty) {
			if (item.quantity > 0) item.quantity += qty;
			else item.quantity = qty;

			this.$forceUpdate();
		},
		viewImage() {
			this.$refs.image.click();
		},
		getImageUrl() {
			var url = process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + this.imageFileName;
			return url;
		},
		test() {
			console.log('test');
		},
		batchApplyQuantity() {
			var vm = this;
			this.items
				.filter(i => i.selected2)
				.forEach(i => {
					i.quantity = vm.batchQuantity;
					i.selected2 = false;
				});

			this.$forceUpdate();
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.items.forEach(function(item) {
				item.selected2 = vm.allSelected;
			});
		},
		// clickClass(c) {
		// 	this.itemClass = c.code;
		// 	this.keyword = null;

		// 	this.showModal = false;

		// 	this.search();
		// },
		// closeModalItems() {
		// 	this.showModal = false;
		// },
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
			if (this.operation == 'S') url += '&for_sale_yn=Y';
			if (this.invoice_type == 'R') url += '&for_return_yn=Y';
			if (this.so_item_filter) url += '&so_item_select_yn=Y';
			//url += '&include_closed_yn=Y';

			//console.log(url);
			return url;
			//return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		},
		selectClass(c) {
			//this.$refs.ac.clear();
			//this.keyword = '';
			//console.log(c);
			this.prevKeyword = this.$refs.ac.$el.children[0].children[1].children[0].value;
			//console.log(this.prevKeyword);
			this.itemClass = c.selectedObject.code;
			this.className = c.selectedObject.name;
			this.imageFileName = c.selectedObject.image_file_name;
			// #3320: 드롭다운에서 클래스를 고르면 그 클래스만으로 조회한다. 키워드 Enter(searchKeyword)가
			// 클래스 검색 팝업용으로 넣어 둔 keyword 는 reset() 전까지 남아 있어, 팝업을 취소한 뒤 고른 클래스가
			// 이전 키워드와 AND 로 묶여 0건이 되던 문제를 막는다. 정상 흐름에서는 이 값이 원래 비어 있다.
			// 다른 회사는 기존 동작을 유지한다.
			if (this.soItemSelect) this.keyword = '';
			this.search();
			//console.log(this.$refs.ac);
			//console.log(str);
		},
		searchKeyword(keyword) {
			//if (!keyword) keyword = this.prevKeyword;

			//console.log(keyword);
			this.keyword = keyword;
			this.prevKeyword = keyword;
			this.search();
			this.$refs.ac.clear();
		},
		acFocus() {
			if (this.focusOnAC) this.$emit('forcedFocusOnAC');
		},
		acEnter() {
			//this.prevKeyword = this.$refs.ac.$el.children[0].children[1].children[0].value;
			//console.log('Hmmm', this.$refs.ac.$el.children[0].children[1].children[0].value);
			//console.log(this.$refs.ac);
			//console.log(this.$refs.ac.$el.firstChild.children[1].children[0]);
		},

		test2(keyword) {
			console.log('input keyword', keyword);
		},

		priceInputEvent(index, price_type, class_code, min_price, cost, price) {
			//console.log(index, price_type, class_code, min_price, cost, price, this.operation);
			//console.log(event, '1');
			//console.log(class_code, event.target.value);
			if (this.operation == 'S' && this.invoice_type == 'R') return;

			if (this.user.company_id == 'arkin') return;

			for (var i = index + 1; i < this.items.length; i++) {
				if (this.items[i].class_code == class_code) {
					if (this.operation == 'S' && this.items[i].net_price > 0) {
						if (price_type == 'N') this.items[i].net_price = price + this.items[i].min_price - min_price;
						else if (price_type == 'R') this.items[i].r_price = price + this.items[i].min_price - min_price;
					} else if (this.operation == 'P') {
						this.items[i].net_price = price + this.items[i].cost - cost;
					}
				}
			}

			this.$forceUpdate();
		},
		keyEnter(ref, index, e) {
			if (index < this.items.length - 1) {
				this.keyDown(ref, index);
			} else if (this.user.company_id == 'newjigu') {
				this.ok();
			} else if (this.soItemSelect && !(e && e.ctrlKey)) {
				// #3320: SO 품목 선택에서 마지막 행 Enter 로 Add. Ctrl+Enter 는 같은 keydown 에서
				// 아래 @keydown.ctrl.enter 핸들러가 이미 ok() 를 부르므로 여기서는 건너뛴다.
				// (둘 다 실행되면 추가 성공 직후 'No item(s) to add' 오류 토스트가 뜬다.)
				this.ok();
			}
		},
		keyDown(ref, index) {
			if (index < this.items.length - 1) {
				//console.log(this.$refs[ref][index + 1]);
				//console.log(this.$refs[ref][index + 1].$el.offsetParent.offsetTop);
				this.$refs[ref][index + 1].$el.select();
				//document.body.scrollTop = this.$refs[ref][index + 1].$el.offsetParent.offsetTop;
				//this.$refs.div_wrapper.scrollTop = this.$refs[ref][index + 1].$el.offsetParent.offsetTop;
				//this.$refs.div_wrapper.scrollTop = this.$refs[ref][index + 1].$el.offsetParent.offsetTop + this.$refs[ref][index + 1].$el.offsetParent.Height - this.$refs.div_wrapper.Height;
				//this.$refs[ref][index + 1].$el.scrollIntoView();
				//this.$nextTick(() => this.$refs[ref][index + 1].$el.scrollIntoView());
				if (this.$refs[ref][index + 1].$el.offsetParent.offsetTop + 2 * this.$refs[ref][index + 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
					this.$refs.div_wrapper.scrollTop += this.$refs[ref][index + 1].$el.offsetParent.scrollHeight + 1;
				}
				//console.log(this.$refs.div_wrapper_parent.scrollHeight);
				//console.log(this.$refs.div_wrapper.scrollTop, this.$refs[ref][index + 1].$el.offsetParent.offsetTop, this.$refs[ref][index + 1].$el.offsetParent.scrollHeight);
			}
		},
		keyUp(ref, index) {
			if (index > 0) {
				this.$refs[ref][index - 1].$el.select();
				this.$refs.div_wrapper.scrollTop = this.$refs[ref][index - 1].$el.offsetParent.offsetTop;
			}
		},
		keyRight(ref, index) {
			if (ref == 'quantity') {
				if (this.user.price_adjust_yn == 'Y') this.$refs['price'][index].$el.select();
				else this.$refs['req_price'][index].$el.select();
			} else if (ref == 'price' && this.operation == 'S') this.$refs['req_price'][index].$el.select();
			else if (((ref == 'price' && this.operation == 'P') || ref == 'req_price') && index < this.items.length - 1) {
				this.$refs['quantity'][index + 1].$el.select();
				if (this.$refs['quantity'][index + 1].$el.offsetParent.offsetTop + 2 * this.$refs['quantity'][index + 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
					this.$refs.div_wrapper.scrollTop += this.$refs['quantity'][index + 1].$el.offsetParent.scrollHeight + 1;
				}
				//this.$refs.div_wrapper.scrollTop = this.$refs['quantity'][index + 1].$el.offsetParent.offsetTop;
			}
		},
		keyLeft(ref, index) {
			if (ref == 'req_price') {
				if (this.user.price_adjust_yn == 'Y') this.$refs['price'][index].$el.select();
				else this.$refs['quantity'][index].$el.select();
			} else if (ref == 'price') this.$refs['quantity'][index].$el.select();
			else if (ref == 'quantity' && index > 0) {
				if (this.operation == 'S') {
					this.$refs['req_price'][index - 1].$el.select();
					this.$refs.div_wrapper.scrollTop = this.$refs['req_price'][index - 1].$el.offsetParent.offsetTop;
				} else {
					this.$refs['price'][index - 1].$el.select();
					this.$refs.div_wrapper.scrollTop = this.$refs['price'][index - 1].$el.offsetParent.offsetTop;
				}
			}
		},
		// keyEnter(ref, index) {
		// 	if (ref == 'quantity') this.$refs['price'][index].$el.select();
		// 	else if (ref == 'price' && index < this.items.length - 1) this.$refs['quantity'][index + 1].$el.select();
		// },
		clear() {
			this.filter = null;
			//inputSelectOnClick();
		},
		closeModal() {
			this.showModal = false;
		},
		setItemClass(itemClass) {
			this.search2(itemClass.code, null);
		},
		popupCanceled() {
			//console.log('canceld');
			//this.keyword = this.prevKeyword;
			//this.setKeywordFocus();
		},
		async search() {
			//console.log(this.operation)
			//console.log('keyword', this.keyword, 'class', this.itemClass);
			if (this.keyword || this.itemClass) {
				if (!this.itemClass && this.keyword.length < 2) {
					this.$toast.error('Search keyword is too short');
					return;
				} else if (!this.itemClass) {
					//console.log('class popup');
					this.modalName = 'ItemClass';
					this.showModal = true;
				} else {
					await this.search2(this.itemClass, this.keyword);
					this.itemClass = null;
				}
			} else {
				this.$toast.error(`Item ${this.headers.class} and Keyword are Empty`);
			}
		},
		async search2(ic, kw) {
			this.allSelected = false;
			var param = {
				class_code: ic,
				keyword: kw,

				include_available: true,
				include_on_board: true,
			};

			if (this.operation == 'S') {
				param.for_sale = true;
				param.ship_to_code = this.ship_to_code;
			} else if (this.operation == 'P') {
				param.for_purchase = true;
				param.vendor_code = this.vendor_code;
			}

			if (this.operation == 'S' && this.invoice_type == 'R') {
				param.for_return = true;
			}

			if (this.user.company_id == 'newjigu') param.include_po_quantity = true;

			if (this.includeInactive) param.include_inactive = true;

			// #3320: 값을 그대로 대입하지 않는다. MyBatis <if test='so_item_select != null'> 은
			// false 에도 참이라 키를 싣는 것과 생략하는 것이 같지 않다.
			if (this.so_item_filter) param.so_item_select = true;

			const { data } = await apiSelectItemList(param);

			// if (data.classList) {
			// 	this.classes = data.classList;
			// 	this.showModal = true;
			// }

			if (this.user.company_id == 'jc') {
				data.itemList.forEach(function(item) {
					/* jc의 경우 warehouse별 on_hand 처리를 위해, locatino code가 고정된 걸로 가정함 */
					item.WH1 = null;
					item.WH2 = null;
					item.WH_NULL = null;
					if (item.wh_on_hand_str) {
						const wh_on_hands = item.wh_on_hand_str.split('||');
						wh_on_hands.forEach(woh => {
							const ohs = woh.split('|');

							if (ohs.length == 2) {
								if (ohs[0] == 'WH1') {
									item.WH1 = Number(ohs[1]);
								} else if (ohs[0] == 'WH2') {
									item.WH2 = Number(ohs[1]);
								} else if (ohs[0] == 'WH_NULL') {
									item.WH_NULL = Number(ohs[1]);
								}
							}
						});
					}
				});
			}

			if (this.operation == 'P')
				data.itemList.forEach(i => {
					if (i.last_sh_price > 0) {
						i.net_price = i.last_sh_price;
					}
				});

			if (data.itemList.length > 0) {
				this.items = data.itemList;
				this.$nextTick(function() {
					this.$refs['quantity'][0].$el.select();
					//this.$refs.ac.clear();
					//console.log(this.prevKeyword);
				});

				//첫번째 input에 focus 두기
			} else {
				this.items = [];
				// #3320: SO 품목 선택에서만 원인을 드러내는 문구를 쓴다. 이 메서드는
				// Purchase(operation='P')·Slip('N')·WH Return 이 공유하므로 기존 문구를 유지해야 한다.
				this.$toast.error(this.so_item_filter ? 'No sellable item in this class' : 'No item is found');
			}

			//this.keyword = null;
		},
		reset() {
			this.keyword = '';
			this.itemClass = null;
			this.className = null;
			this.items = [];
			//this.$refs.ac.clear();
			this.setKeywordFocus();
		},
		close() {
			this.reset();
			this.$emit('close');
		},
		ok() {
			//var selectedItems = this.items.filter(item => item.quantity && (this.operation == 'N' || item.net_price || item.net_price === 0));
			//console.log(this.items.filter(item => item.quantity && this.operation == 'N'));
			//var selectedItems = this.items.filter(item => item.quantity && this.operation == 'N');
			//var selectedItems = this.items.filter(item => item.quantity > 0 || (this.operation == 'N' && item.quantity < 0));
			var selectedItems = []; //this.items.filter(item => item.quantity > 0 || (this.operation == 'N' && item.quantity < 0));
			this.items
				.filter(item => item.quantity > 0 || (this.operation == 'N' && item.quantity < 0))
				.forEach(i => {
					selectedItems.push(_.cloneDeep(i));
				});

			if (selectedItems.length > 0) {
				this.$emit('set-items', selectedItems);
				this.$toast.success('Item(s) added.');
				this.reset();
			} else {
				this.$toast.error('No item(s) to add');
			}
			//this.close();
			this.items = [];

			//this.$refs.ac.focus();
			this.setKeywordFocus();
			if (this.user.company_id != 'newjigu')
				//뉴지구는 그냥 지워지게
				this.$refs.ac.$el.children[0].children[1].children[0].value = this.prevKeyword;
			//this.keyword = this.prevKeyword;
			//this.$refs.ac.$el.children[0].children[1].children[0].dispatchEvent(new Event('keypress'));
		},
		setKeywordFocus() {
			this.$refs.ac.$el.children[0].children[1].children[0].focus();
		},
		keyInput(ev) {
			//console.log(ev);
			if (ev.keyCode == 27) this.close();
		},
		async getClassInfo(class_code) {
			const { data } = await apiSelectItemClass({ code: class_code });
			this.imageFileName = data.itemClass.image_file_name;
		},
	},
	created() {
		//console.log('initial itemn class', this.initialItemClass);
		//console.log('initial itemn class', this.initialItemClass);
		//console.log('initial keyword', this.initialKeyword);
		this.items = this.initialItems;
		this.itemClass = this.initialItemClass;
		this.className = this.initialClassName;
		this.keyword = this.initialKeyword;

		//console.log(this.operation, this.invoice_type);

		//console.log('item class', this.itemClass);
		//console.log('keyword', this.keyword);
		if (this.itemClass) this.getClassInfo(this.itemClass);

		if (this.keyword || this.itemClass) {
			this.search();
		}
	},
	mounted() {
		inputSelectOnClick();
		//console.log('item class 2', this.itemClass);
		//console.log('keyword 2', this.keyword);

		// if (this.initialItems.length > 0) {
		// 	setTimeout(() => {
		// 		this.$refs['quantity'][0].$el.focus();
		// 	}, 10);
		// }

		// this.$nextTick(function() {
		// 	if (this.initialItems.length > 0) {
		// 		this.$refs['quantity'][0].$el.focus();
		// 	}
		// });

		setTimeout(() => {
			//console.log(this.$refs.ac.$el.children[0].children[1].children[0]);
			//this.$refs.spkeyword.focus();
			//this.$refs.ac.focus();
			this.setKeywordFocus();
		}, 10);

		// var vm = this;
		// window.addEventListener('keyup', function(ev) {
		// 	vm.keyInput(ev);
		// });

		var vm = this;

		window.addEventListener('keyup', function(ev) {
			//self.myMethod(ev); // declared in your component methods
			if (ev.code == 'Escape') vm.close();
		});

		//console.log(this.initialItems);
	},
};
</script>

<style></style>
